module.exports = __webpack_public_path__ + "static/illustration-mobile-ac471519c63ced5fff4c05bf2e9e1c56.jpg";